import tenantsConfigRaw from '../../config/tenants.json?raw';

export interface TenantFooterLink {
  label: string;
  href: string;
}

interface TenantGoogleAnalyticsSettings {
  measurementId?: string;
}

interface TenantSettings {
  websiteBaseHref?: string;
  footer?: TenantFooterLink[];
  googleAnalytics?: TenantGoogleAnalyticsSettings;
  timetableNotesEnabled?: boolean;
}

type TenantsConfig = Record<string, TenantSettings>;

function parseTenantsConfig(rawConfig: string): TenantsConfig {
  const parsed = JSON.parse(rawConfig) as unknown;

  if (!parsed || typeof parsed !== 'object') {
    return {};
  }

  return parsed as TenantsConfig;
}

const tenantsConfig = parseTenantsConfig(tenantsConfigRaw);

export function getTenantFooterLinks(tenant: string): TenantFooterLink[] {
  const normalizedTenant = tenant.trim().toLowerCase();

  if (!normalizedTenant) {
    return [];
  }

  return tenantsConfig[normalizedTenant]?.footer ?? [];
}

export function getTenantWebsiteBaseHref(tenant: string): string | null {
  const normalizedTenant = tenant.trim().toLowerCase();

  if (!normalizedTenant) {
    return null;
  }

  return tenantsConfig[normalizedTenant]?.websiteBaseHref ?? null;
}

export function getTenantGoogleAnalyticsMeasurementId(
  tenant: string,
): string | null {
  const normalizedTenant = tenant.trim().toLowerCase();

  if (!normalizedTenant) {
    return null;
  }

  return (
    tenantsConfig[normalizedTenant]?.googleAnalytics?.measurementId ?? null
  );
}

export function isTimetableNotesEnabled(tenant: string): boolean {
  const normalizedTenant = tenant.trim().toLowerCase();

  if (!normalizedTenant) {
    return true;
  }

  return tenantsConfig[normalizedTenant]?.timetableNotesEnabled ?? true;
}
